'use client';
import './mobileIntro.scss';

import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

/* eslint-disable @next/next/no-img-element */
import { Button, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material';

import { MixpanelEvent } from '@/services/eventEnums';

import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { MixpanelTracking } from '@/services/mixpanel';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import { useTranslation } from 'react-i18next';

export default function ExploreScreen({
  showContentComponent,
  dialogFlowRef,
  setShowContentComponent,
  setOpen,
  allSteps,
}: {
  showContentComponent: any;
  dialogFlowRef: any;
  setShowContentComponent: any;
  setOpen: any;
  allSteps: any;
}) {
  const { t } = useTranslation('orderImagery');
  return (
    <>
      <IconButton
        name="back"
        aria-label="close-delete-item-dialog"
        className="close-btn"
        onClick={() => {
          setShowContentComponent(allSteps['main']);
        }}
        sx={{
          position: 'absolute',
          top: 5,
          left: 8,
        }}
      >
        <ArrowBackOutlinedIcon />
      </IconButton>
      <DialogTitle sx={{ m: 0, p: 2, textAlign: 'center' }} id="customized-dialog-title">
        {`${t('welcomeTo', 'Welcome to')} SkyWatch`}
      </DialogTitle>
      <IconButton
        name="Close Delete Item"
        aria-label="close-delete-item-dialog"
        className="close-btn"
        onClick={() => {
          setOpen(false);
          MixpanelTracking.getInstance().track(MixpanelEvent.EXPLORE_MOBILE_INTRO_DIALOG_CLOSE);
        }}
        sx={{
          position: 'absolute',
          right: 8,
          top: 5,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="body2">
          {t(
            'infoDesc',
            ' SkyWatch provides access to high-resolution satellite imagery from multiple providers. Search, preview, and order imagery for any location on Earth. Perfect for agriculture infrastructure monitoring, environmental analysis, and more.'
          )}
        </Typography>
        <Stack display="block" gap="10px">
          <Button
            sx={{ marginBottom: '10px' }}
            endIcon={<ArrowForwardOutlinedIcon sx={{ fontSize: '1rem !important' }} />}
            fullWidth
            color="primary"
            variant="contained"
            onClick={() => {
              setShowContentComponent(allSteps['form']);
              MixpanelTracking.getInstance().track(
                MixpanelEvent.EXPLORE_MOBILE_INTRO_LEARN_MORE_CLICK
              );
              MixpanelTracking.getInstance().track(MixpanelEvent.EXPLORE_MOBILE_INTRO_FORM_OPEN);
            }}
          >
            {t('learnMore', 'Learn more')}
          </Button>
          <Button
            variant="outlined"
            fullWidth
            onClick={() => {
              setOpen(false);
              MixpanelTracking.getInstance().track(
                MixpanelEvent.EXPLORE_MOBILE_INTRO_CONTINUE_EXPLORING_CLICK
              );
            }}
          >
            {t('continueExploring', 'Continue exploring')}
          </Button>
        </Stack>
      </DialogContent>
    </>
  );
}
